import React, { Fragment } from 'react';
import intl from 'react-intl-universal';
import Grid from '@material-ui/core/Grid';
import Button from 'src/ui/library/Button';
import CurrencyFormat from 'react-currency-format';
import { PieChart, Pie, Cell, BarChart, Bar, YAxis, LabelList } from 'recharts';
import ChevronRight from '@material-ui/icons/ChevronRight';
import WhatIfEmployeeRowContainer from '../containers/WhatIfEmployeeRowContainer';

class WhatIfResultsDetailPres extends React.Component {
  render() {
    const {
      resultToShow,
      totalSalaryBarData,
      radialData,
      otherConsiderationsData,
      selectedConsiderationData,
      handleOnClick,
      selectedEmpKey,
      onCalculate,
    } = this.props;

    return (
      <div className="whatif-results">
        <div className="whatif-results-body">
          <div className="whatif-results-detail">
            <Grid container direction="column" alignItems="center">
              {selectedEmpKey && (
                <Fragment>
                  <Grid container xs={12} className="whatif-results-detail-grid-item-input">
                    <WhatIfEmployeeRowContainer {...this.props} mode="detail" key={selectedEmpKey} id={selectedEmpKey} />
                    <Button styleType="primary" onClick={onCalculate}>
                      Calculate
                    </Button>
                  </Grid>
                </Fragment>
              )}
              <Grid item xs={12} className="whatif-results-detail-grid-item">
                <div className="whatif-results-detail-row-header">
                  <div className="whatif-results-detail-row-header-1">{intl.get('whatif.detailPage.labels.header1')}</div>
                  <div className="whatif-results-detail-row-header-breakdown-cost">
                    <CurrencyFormat
                      value={resultToShow.totalCompensationWithEmployees}
                      displayType={'text'}
                      thousandSeparator={true}
                      decimalScale={0}
                      prefix={intl.get('whatif.calculator.currency.prefix')[resultToShow.outputCurrency]}
                      suffix={intl.get('whatif.calculator.currency.suffix')[resultToShow.outputCurrency]}
                    />
                  </div>
                </div>
                <div className="whatif-results-detail-row-1">
                  <Grid container wrap="nowrap">
                    <Grid item xs={6} className="whatif-results-detail-row-1-grid-item">
                      <div className="whatif-results-detail-row-1-grid-item-header">{intl.get('whatif.detailPage.labels.totalCost')}</div>
                      <Grid container className="whatif-results-detail-row-1-grid-item-content-pie">
                        <Grid item xs={6}>
                          <div className="whatif-results-detail-row-1-grid-item-content-pie-centerpiece">
                            <CurrencyFormat
                              value={resultToShow.totalCompensationWithEmployees}
                              displayType={'text'}
                              thousandSeparator={true}
                              decimalScale={0}
                              prefix={intl.get('whatif.calculator.currency.prefix')[resultToShow.outputCurrency]}
                              suffix={intl.get('whatif.calculator.currency.suffix')[resultToShow.outputCurrency]}
                            />
                          </div>
                          <PieChart height={220} width={250}>
                            <Pie data={radialData} innerRadius={83} outerRadius={101.5}>
                              {radialData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={entry.color} />
                              ))}
                            </Pie>
                          </PieChart>
                        </Grid>
                        <Grid item xs={6}>
                          <div className="whatif-results-detail-row-1-grid-item-content-pie-legend">
                            {radialData.map((entry, index) => (
                              <div className="whatif-results-detail-row-1-grid-item-content-pie-legend-item">
                                <div
                                  className="whatif-results-detail-row-1-grid-item-content-pie-legend-item-rectangle"
                                  style={{ backgroundColor: entry.color }}>
                                  {' '}
                                </div>
                                <div className="whatif-results-detail-row-1-grid-item-content-pie-legend-item-info">
                                  <div className="whatif-results-detail-row-1-grid-item-content-pie-legend-item-info-name">
                                    {entry.name}
                                  </div>
                                  <div className="whatif-results-detail-row-1-grid-item-content-pie-legend-item-info-value">
                                    <CurrencyFormat
                                      value={entry.value}
                                      displayType={'text'}
                                      thousandSeparator={true}
                                      decimalScale={0}
                                      prefix={intl.get('whatif.calculator.currency.prefix')[resultToShow.outputCurrency]}
                                      suffix={intl.get('whatif.calculator.currency.suffix')[resultToShow.outputCurrency]}
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={6} className="whatif-results-detail-row-1-grid-item">
                      <div className="whatif-results-detail-row-1-grid-item-header">
                        {intl.get('whatif.detailPage.labels.salaryDetails')}
                      </div>
                      <div className="whatif-results-detail-row-1-grid-item-content-bar">
                        <BarChart
                          className="whatif-results-detail-row-1-grid-item-content-bar-chart"
                          data={totalSalaryBarData}
                          layout="vertical"
                          // margin={{ left: 0, right: 100 }}
                          width={600}
                          height={250}>
                          <YAxis hide={false} type="category" dataKey="name" interval={0} axisLine={true} tickLine={false} width={200} />
                          <Bar dataKey="value" fill={this.props.colors[0]} stackId="main">
                            {totalSalaryBarData.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={this.props.colors[0]} />
                            ))}
                            <LabelList
                              dataKey="value"
                              position="right"
                              fill="rgba(46,46,56,0.8)"
                              formatter={value => {
                                return this.props.formatCurrency(value, resultToShow.outputCurrency);
                              }}
                            />
                          </Bar>
                        </BarChart>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
              <Grid item xs={12} className="whatif-results-detail-grid-item">
                <div className="whatif-results-detail-row-header">
                  <div className="whatif-results-detail-row-header-2">{intl.get('whatif.detailPage.labels.header2')}</div>
                </div>
                <div className="whatif-results-detail-row-2">
                  <Grid container>
                    <Grid item xs={4} className="whatif-results-detail-row-2-grid-item-button-group">
                      {Object.keys(otherConsiderationsData).map(value => {
                        let className = 'whatif-results-detail-row-2-grid-item-button';
                        if (value === selectedConsiderationData) {
                          className = 'whatif-results-detail-row-2-grid-item-button-selected';
                        }
                        return (
                          <div className={className} aria-label={value} onClick={() => handleOnClick(value)}>
                            <div className={className + '-text'}>{value}</div>
                            <div className="whatif-results-detail-row-2-grid-item-button-chevron">
                              <ChevronRight />
                            </div>
                          </div>
                        );
                      })}
                    </Grid>
                    <Grid item xs={8} className="whatif-results-detail-row-2-grid-item-information">
                      <div className="whatif-results-detail-row-2-grid-item-information-text">
                        {otherConsiderationsData[selectedConsiderationData]}
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

export default WhatIfResultsDetailPres;
